import { Link } from 'react-router-dom';
import { colors } from '../../styles/theme';

/** Shown where a Series could be contributed to while the person's Membership Agreement is
 *  not yet approved (S-41): the Membership Agreement is the base contract, so it comes first. */
export default function MembershipFirstNote(): JSX.Element {
  return (
    <output className="block text-xs mb-3" style={{ color: colors.inkSoft, margin: 0 }}>
      Your Membership Agreement comes first. You can contribute to a series once we have reviewed
      it.{' '}
      <Link to="/client/contracts" style={{ color: colors.navy, fontWeight: 600 }}>
        Go to my Membership Agreement →
      </Link>
    </output>
  );
}
